export default __webpack_public_path__ + "static/media/99.8ab6822a.jpg";